<template>
  <div>
    <p>{{ row.skCustRef }}</p>
    <p>{{ row.skOrderNum }}</p>
  </div>
</template>

<script>
export default {
  name: 'tdOrderNum',
  props: ['row'],
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdOrderNum.vue